import {InteractionType} from '@azure/msal-browser'
import {MsalAuthenticationTemplate, MsalProvider} from '@azure/msal-react'
import 'antd/dist/reset.css'
import React, {Suspense} from 'react'
import ReactDOM from 'react-dom/client'
// eslint-disable-next-line react-refresh/only-export-components
const App = React.lazy(() => import('./App'))

import {ConfigProvider, ThemeConfig} from 'antd'
import {Loading} from './components/loading'
import msalInstanceFactory from './msalInstance'
import {handleDirectAccess} from './components/Access'

const msalInstance = await msalInstanceFactory()

const theme: ThemeConfig = {
  token: {
    padding: 0,
    fontWeightStrong: 200,
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    colorPrimary: '#1976d2',
    colorBgLayout: 'transparent',
  },
  components: {
    Spin: {
      dotSizeLG: 64,
    },
  },
}

handleDirectAccess()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Suspense fallback={<Loading />}>
      <MsalProvider instance={msalInstance}>
        <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
          <ConfigProvider theme={theme}>
            <App />
          </ConfigProvider>
        </MsalAuthenticationTemplate>
      </MsalProvider>
    </Suspense>
  </React.StrictMode>,
)
